export default __webpack_public_path__ + "static/LittlePrinceBusinessman-1bc44681268d2d4bf6616f239011c421.png";